import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { DistrictAddFacilityComponent } from "./district-add-facility/district-add-facility.component";
import { DistrictEditFacilityComponent } from "./district-edit-facility/district-edit-facility.component";
import { DataService_FacilitySetup } from "./shared/data.service";

@Component({
	selector: "app-facility-setup",
	templateUrl: "./facility-setup.component.html",
	styleUrls: ["./facility-setup.component.css"],
})
export class FacilitySetupComponent implements OnInit {
	constructor(private userService: UserService, private FacilitySetupService: DataService_FacilitySetup, private dialogService: DialogService) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadFacility();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";
	ToggleText: any = "Deactivate Facility";
	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedFacility: any;
	lstFacility: any = [];

	//Filter lists
	lstDefinedByDesc: any = [];
	lstActiveDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "FacilityName", header: "Facility Name" },
		{ field: "FacilityCD", header: "Code" },
		{ field: "AddressDesc", header: "Address" },
		{ field: "WorkPhone", header: "Phone" },
		{ field: "DefinedByDesc", header: "Defined By" },
		{ field: "ActiveDesc", header: "Defined By" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadFacility() {
		this.loading = true;

		var result = this.FacilitySetupService.LoadFacility(this.user.userID);
		result.subscribe(
			(response) => {
				this.lstFacility = response;

				//Update address desc
				for (var i = 0; i < this.lstFacility.length; i++) {
					var next: any = this.lstFacility[i];
					var First: any = true;

					if (next.Street1 != undefined && next.Street1 != "") {
						First = false;
						next.AddressDesc = next.Street1;
					}
					if (next.Street2 != undefined && next.Street2 != "") {
						if (!First) {
							next.AddressDesc = next.AddressDesc + ", " + next.Street2;
						} else {
							First = false;
							next.AddressDesc = next.Street2;
						}
					}
					if (next.City != undefined && next.City != "") {
						if (!First) {
							next.AddressDesc = next.AddressDesc + ", " + next.City;
						} else {
							First = false;
							next.AddressDesc = next.City;
						}
					}
					if (next.State != undefined && next.State != "") {
						if (!First) {
							next.AddressDesc = next.AddressDesc + ", " + next.State;
						} else {
							First = false;
							next.AddressDesc = next.State;
						}
					}
					if (next.Zip != undefined && next.Zip != "") {
						if (!First) {
							next.AddressDesc = next.AddressDesc + ", " + next.Zip;
						} else {
							First = false;
							next.AddressDesc = next.Zip;
						}
					}
				}

				//Load Data Filter Lists
				this.lstDefinedByDesc = Array.from(new Set(this.lstFacility.map((item: any) => item.DefinedByDesc))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstFacility.map((item: any) => item.ActiveDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.errorMessage = "";

		this.loadFacility();
	}

	//Custom Button Methods
	onAddFacility() {
		this.errorMessage = "";

		var ref = this.dialogService.open(DistrictAddFacilityComponent, {
			header: "Add Facility",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadFacility();
			}
		});
	}

	onEditFacility() {
		this.errorMessage = "";

		if (this.SelectedFacility == undefined) {
			this.errorMessage = "Select a facility to edit";
			return;
		}

		var ref = this.dialogService.open(DistrictEditFacilityComponent, {
			header: "Edit Facility",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SelectedFacility: this.SelectedFacility,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadFacility();
			}
		});
	}

	onToggleFacility() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedFacility == undefined) {
			this.errorMessage = "Select a facility to activate or deactivate";
			return;
		}

		var ChangeTo = this.SelectedFacility.ActiveDesc == "Active" ? 0 : 1;

		//Call SP
		var result = this.FacilitySetupService.ToggleFacility(this.SelectedFacility.FacilityID, ChangeTo);
		result.subscribe(
			(response) => {
				this.onRowUnselect(null);
				this.loadFacility();
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedFacility = val.data;

		this.ToggleText = "Deactivate Facility";
		if (this.SelectedFacility.ActiveDesc == "Inactive") {
			this.ToggleText = "Activate Facility";
		}
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedFacility = null;

		this.ToggleText = "Deactivate Facility";
	}
	onRowDblClick(Facility) {
		this.errorMessage = "";

		this.SelectedFacility = Facility;

		this.ToggleText = "Deactivate Facility";
		if (this.SelectedFacility.ActiveDesc == "Inactive") {
			this.ToggleText = "Activate Facility";
		}

		this.onEditFacility();
	}
	////////////////////////////////////////////
}
